export default __webpack_public_path__ + "static/media/authentication.f4d09626.svg";